module.exports = __webpack_public_path__ + "static/media/Group.3dd7f8f0.png";